import { Container, Grid, Paper, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { AdminPageTitle } from "../../components/adminPageTitle";
import { loadAdminDashboardStats } from "./loadData";
import { StatsCard } from "./StatsCard";
import TotalFeedback from "./TotalFeedback";

const AdminDashboard = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    loadAdminDashboardStats(setLoading).then(setStats);
  }, [location.pathname]);
  console.log("these are stats", stats);
  const dataUsers = [
    {
      value: stats?.totalUsers || 0,
      title: "Total Users",
      color: "black",
      icon: "user",
    },
    {
      value: stats?.totalAdmins || 0,
      title: "Total Admins",
      color: "black",

      icon: "user",
    },
    {
      value: stats?.totalActiveUsers || 0,
      title: "Total Active Users",
      color: "black",
      icon: "user",
    },
    {
      value: stats?.totalInactiveUsers || 0,
      title: "Total In-Active Users",
      color: "black",

      icon: "user",
    },
    {
      value: stats?.totalCompanies || 0,
      title: "Total Companies",
      icon: "user",
    },
    {
      value: stats?.totalJobSeekers || 0,
      title: "Total Job Seekers",
      icon: "user",
    },

    {
      value: stats?.totalJobsPosted || 0,
      title: "Total Jobs Posted",
      icon: "user",
    },
    {
      value: stats?.totalApplications || 0,
      title: "Total Jobs Applications",
      icon: "user",
    },
  ];
  const userPieChartData = [
    {
      value: stats?.totalAdmins || 0,
      title: "Total Admins",
      color: "black",

      icon: "user",
    },
    {
      value: stats?.totalCompanies || 0,
      title: "Total Companies",
      icon: "user",
    },
    {
      value: stats?.totalJobSeekers || 0,
      title: "Total Job Seekers",
      icon: "user",
    },
  ];
  const jobPieChartData = [
    {
      value: stats?.totalJobsPosted || 0,
      title: "Total Jobs Posted",
      icon: "user",
    },
    {
      value: stats?.totalApplications || 0,
      title: "Total Jobs Applications",
      icon: "user",
    },
  ];

  return (
    <Container size={1900} mt="xl">
      <AdminPageTitle title="Admin Dashboard" />
      <StatsCard data={dataUsers} cols={4} />
      <Grid mt="xl">
        <Grid.Col lg={6}>
          <TotalFeedback
            data={userPieChartData.map((item) => item.value)}
            labels={userPieChartData.map((item) => item.title)}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <TotalFeedback
            data={jobPieChartData.map((item) => item.value)}
            labels={jobPieChartData.map((item) => item.title)}
          />
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default AdminDashboard;
